module.exports = __webpack_public_path__ + "static/RobotScanE0505-708a23602bcf03cf6633767df71e657b.png";